import {Injectable} from "@angular/core";
import {Adapter} from "./adapter";

export class PaymentTerms {

    public PayTerm_ID = null;
    public PayTerm_Code = null;
    public PayTerm_Desc = null;
    public CreditDays = null;
    public AdvancePercent = null;
    public Active = null;
    public CreatedBy = null;
    public CreatedOn = null;
    public ModifiedBy = null;
    public ModifiedOn = null;

    constructor(public initVal: Partial<PaymentTerms>) {
        Object.assign(this, initVal);
    }
}

@Injectable()
export class PaymentTermsAdapter implements Adapter<PaymentTerms> {
    adapt(item: any): PaymentTerms {
        return new PaymentTerms(item);
    }
}